import BaseRepository from '@/api/repositories/BaseRepository';

export default class RentalCarExtraCostsRepository extends BaseRepository {
	getAll(onlyActive) {
		return this.get(`rentalcarpricing/extra-costs?only-active=${onlyActive}`, {});
	}

	save(data) {
		return this.put(`rentalcarpricing/extra-costs`, {}, data);
	}
}
